import api from "../../../../services/api";

const getSignature = () => localStorage.getItem("signature");

const post = async (path: string, body: Record<string, any>) => {
  const response = await api.post(path, {
    signature: getSignature(),
    ...body,
  });
  return response.data?.data;
};

export const listResolutions = async (
  companyId: string,
  companyType: string,
  projectId?: number
) =>
  post("projectService/resolution/listResolutions", {
    company_id: companyId,
    company_type: companyType,
    ...(projectId ? { project_id: projectId } : {}),
  });

export const createResolution = async (
  companyId: string,
  companyType: string,
  payload: Record<string, any>
) =>
  post("projectService/resolution/createResolution", {
    company_id: companyId,
    company_type: companyType,
    ...payload,
  });

export const updateResolution = async (
  companyId: string,
  companyType: string,
  id: number,
  payload: Record<string, any>
) =>
  post("projectService/resolution/updateResolution", {
    company_id: companyId,
    company_type: companyType,
    id,
    ...payload,
  });

export const deleteResolution = async (
  companyId: string,
  companyType: string,
  id: number
) =>
  post("projectService/resolution/deleteResolution", {
    company_id: companyId,
    company_type: companyType,
    id,
  });

export const setDefault = async (
  companyId: string,
  companyType: string,
  id: number
) =>
  post("projectService/resolution/setDefault", {
    company_id: companyId,
    company_type: companyType,
    id,
  });
